var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.list.length > 0),expression:"list.length > 0"}],staticClass:"menuAdvertising"},[_c('el-carousel',{attrs:{"interval":3000,"autoplay":true}},_vm._l((_vm.list),function(item,index){return _c('el-carousel-item',{key:index},[_c('a',{attrs:{"href":item.link,"target":"_blank"}},[_c('img',{attrs:{"src":item.pic}})])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bce7b616","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuAd/index.vue
// module id = 839
// module chunks = 2